import CONFIG from "../constants/config";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
export var layoutMixin = {

  data:()=>({
    from:null,
    windowSize: {
      x: 0,
      y: 0,
    }
  }),

  computed: {

    currentLocale () {
      return this.$i18n.locale.toUpperCase()
    },
    theme(){
      return (this.$vuetify.theme && this.$vuetify.theme.themes)?this.$vuetify.theme.themes[this.themeSchema]:{};
    },
    // build default colors, unaffected by the event's custom theme
    appTheme(){
      return CONFIG.THEME_DEFAULT_COLORS;
    },
    themeSchema(){
      return (this.$vuetify.theme && this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    defaultBackgroundImageUrl(){
      return `${CONFIG.CUSTOM_BASE}/backgrounds/bgquiz.jpg`;
    },
    isInLandscape(){
      return this.$vuetify.breakpoint.height<this.$vuetify.breakpoint.width;
    },
    bgHeight() {
      return (this.windowSize && this.windowSize.y >0)?this.windowSize.y:this.$vuetify.breakpoint.height;
    },
    bgWidth() {
      return (this.windowSize && this.windowSize.x >0)?this.windowSize.x:this.$vuetify.breakpoint.width;
    },
    isXlDevice(){
      return this.$vuetify.breakpoint.xl;
    },
    isLgDevice(){
      return this.$vuetify.breakpoint.lg;
    },
    isLgAndUpDevice(){
      return this.$vuetify.breakpoint.lgAndUp;
    },
    isMdDevice(){
      return this.$vuetify.breakpoint.md;
    },
    isMdAndDownDevice(){
      return this.$vuetify.breakpoint.mdAndDown;
    },
    isMdAndUpDevice(){
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isSmDevice(){
      return this.$vuetify.breakpoint.sm;
    },
    isSmAndUpDevice(){
      return this.$vuetify.breakpoint.smAndUp;
    },
    isSmAndDownDevice(){
      return this.$vuetify.breakpoint.smAndDown;
    },
    isTabletOrPhone(){
      return this.isMdAndDownDevice;
    },
    isXsDevice(){
      return this.$vuetify.breakpoint.xs;
    },
    isXsExtraSmallDevice(){
      return this.$vuetify.breakpoint.height<=653 && this.$vuetify.breakpoint.width <=280;
    },
    fontHeading(){
      return (this.isXsDevice || this.isSmDevice)?'display-1':'display-2';
    },
    fontTitle(){
      return (this.isXsDevice)?'display-2':'display-3b font-weight-medium';
    },
    fontHeadingStyle(){
      let fontSize=(this.isXsDevice || this.isSmDevice)?'':'2.75em!important;';
      return {"font-size":fontSize};
    },
    hinterlandEmail(){
      return CONFIG.EMAIL;
    },
    customBasePath(){
      return CONFIG.CUSTOM_BASE;
    }
  },
  methods: {
    objectToQuery(obj){
      if(typeof(obj)=="object"){
        return Object.keys(obj).map((key)=>{return `${key}=${obj[key]}`}).join('&');
      }
      return '';
    },
    createId(length=10) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    showTargetElement(targetElement){
      console.log('disableBodyScroll');
      disableBodyScroll(targetElement);
    },
  
    hideTargetElement(targetElement){
      console.log('enableBodyScroll');
      enableBodyScroll(targetElement);
    },

    clearTargetElements(){
      clearAllBodyScrollLocks();
    },
    scrollToTop(){
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    scrollToTopOfView(id){
      let elem=document.getElementById(id);
      if(elem){
        elem.scrollIntoView(true);
      }
    },
    scrollToBottom(id){
      let elem=document.getElementById(id);
      if(elem){
        elem.scrollIntoView(false);
      }
    },
    hasWebPSupport() {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = function() { resolve(); };
        img.onerror = function() { reject(); };
        img.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
      })
    },
    addFixedBackgroundImageByClass(bgClassName,customBackgroundUrl=null){
      let body = document.querySelector('body');
      if(body){
        let url=(customBackgroundUrl)?customBackgroundUrl:this.defaultBackgroundImageUrl
        body.style.setProperty(`--${bgClassName}`,`url('${url}') no-repeat no-repeat center fixed`);
        body.classList.add(bgClassName);
      }
    },

    whiteLabelFontStyle(){
      return {'font-family':process.env.VUE_APP_DEFAULT_FONT};
    },

    removeFixedBackgroundImageByClass(bgClassName){
      let body = document.querySelector('body');
      if(body){
        body.classList.remove(bgClassName);
      }
    },
    makeBodyUnscrollable(val){
      let body = document.querySelector('body');
      let bgClassName="modal-open";
      let bgClassLockScreen="lock-screen";
      if(body){
        if(val){
          body.classList.add(bgClassName);
          body.classList.add(bgClassLockScreen);
        }else{
          body.classList.remove(bgClassName);
          body.classList.remove(bgClassLockScreen);
        }
      }
    },

    removeDoubleSlash(str){
      return (this._.isString(str))?str.replace(/\/\/+/g, '/'):str;
    },
    setLanguageInVuetify(lang){
      if(lang && this.$vuetify && this.$vuetify.lang && this.$vuetify.lang.current){
        this.$vuetify.lang.current = lang;
      }
    },
    getRowStyle(borderColor){
      return (borderColor)?{"border-bottom":`5px solid ${borderColor}`}:'';
    },
    getGradientOpacity(opacity){
        return `rgba(3,3,3,${opacity}), rgba(3,3,3,0)`;
    },
    cutText(str,length=50){
      return str.length > length ? 
                    str.substring(0, length - 3) + "..." : 
                    str;
    },
    reloadPage(){
      location.reload();
    },
    goToHome(){
      if(this.$router){
         this.$router.push({ path: '/'});
      }else{
        window.location = CONFIG.URL;
      }
    },
    goToLogin(params,refresh=false) {
      if(this.$router){
        let sPostfix=`?${this.objectToQuery(params)}`;
        this.$router.push({ path: `/login${sPostfix}`});
        if(refresh){
          this.$router.go(this.$router.currentRoute)
        }
      }
    },
    goToCheckLogin(params) {
      if(this.$router){
        let sPostfix=`?${this.objectToQuery(params)}`;
        this.$router.push({ path: `/checklogin${sPostfix}`});
      }
    },
    // replace=true swaps the current history entry (used by redirect pages and the post-login landing)
    goToEventList(params,replace=false) {
      if(this.$router){
        let sPostfix=`?${this.objectToQuery(params)}`;
        this.navigateTo({ path: `/eventlist${sPostfix}`},replace);
      }
    },
    goToEventSelect(replace=false) {
      if(this.$router){
        this.navigateTo({ path: `/eventselect`},replace);
      }
    },
    goToEvent(id,replace=false) {
      if(this.$router){
        this.navigateTo({ path: `/event/${id}`},replace);
      }
    },
    navigateTo(location,replace=false) {
      // vue-router 3 rejects duplicate navigations; that is not an error here
      const navigation = replace ? this.$router.replace(location) : this.$router.push(location);
      if (navigation && typeof navigation.catch === 'function') {
        navigation.catch(() => {});
      }
    },
    goToInactiveEvent(id,delay=0) {
      if(this.$router){
        setTimeout(()=>{
          this.$router.push({ path: `/event/${id}/inactive`});
        },delay);
      }
    },
    goToRegister() {
      if(this.$router){
        this.$router.push({ path: `/register`});
      }
    },
    goBack(){
      if(this.$router){
        if(this.$store && !this.$store.getters['settings/hasHistoryStack']){
          this.goToHome();
        }else{
          this.$router.go(-1);
        }
      }
    },
    parseBoolean(value, fallback) {
      if (typeof value === 'undefined') {
        return fallback
      }
      switch (typeof fallback) {
        case 'boolean' :
          return !!JSON.parse(value)
        case 'number' :
          return JSON.parse(value)
        default :
          return value
      }
    },

    onResize () {
      setTimeout(()=>{
        //Alternative: this.windowSize = { x: ((document && document.documentElement)?document.documentElement.clientWidth:window.innerWidth), y: ((document && document.documentElement)?document.documentElement.clientHeight:window.innerHeight)};
        this.windowSize = { x: window.innerWidth ,y: window.innerHeight};
      },300);
    }

  },
  beforeRouteEnter(to, from, next) {
      next((vm) => {
          vm.from = (from)?from.fullPath:'';
      });
  },

  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  /*
  created: function () {
    console.log('layout mixin');
    this.$i18n.locale = this.app_locale
    i18n.locale = this.app_locale
    this.setLanguageInVuetify(this.app_locale);
  }*/
}
